import {TOption} from './TOption'

export const ORDER_STATUS: TOption[] = [
  {value: '0', label: 'Pengajuan'},
  {value: '1', label: 'Ditinjau'},
  {value: '2', label: 'Revisi'},
  {value: '3', label: 'Negosiasi'},
  {value: '4', label: 'Proses Pengambilan'},
  {value: '5', label: 'Selesai'},
  {value: '6', label: 'Negosiasi Disetujui'},
  {value: '7', label: 'Proses SIP'},
  {value: '9', label: 'Proses Ke Anper'},
  {value: '10', label: 'Proses Kontrak'},
  {value: '11', label: 'Siap Diambil'},
  {value: '91', label: 'Pengajuan Amandemen'},
  {value: '90', label: 'Ditolak'},
]
